const jobTitleToSlug = (title) => (title.replace(/-and-|-|\s|[^a-zA-Z0-9]/g, '').toLowerCase());

export default jobTitleToSlug;
